import React, {FC, useState} from "react";
import {motion} from "framer-motion";
import {TitleGreenSpanSecond} from "@components/title/title-green-span-second";
import {i18translateType} from "../../../@types/types-body";
import {useTranslation} from "next-i18next";

const ConsultationService: FC<{namespace:string}> = ({namespace}) => {
    const [activeTab, setActiveTab] = useState<string>("technical-content")
    const {t}: i18translateType = useTranslation(namespace);
    return (<div className={"container mx-auto mt-12"}>
            <div className="flex flex-wrap justify-center my-4">
                <button onClick={() => setActiveTab('technical-content')}
                        className={`${activeTab === "technical-content" ? 'bg-crowlyn' : 'bg-crowlyn-button'} hover:bg-crowlyn hover:text-white text-white rounded-xl text-base sm:text-xl md:text-base px-3 py-2 my-2 mx-2 text-center`}>
                    {t(`consultation_technical_content`)}
                </button>
                <button onClick={() => setActiveTab('project-content')}
                        className={`${activeTab === "project-content" ? 'bg-crowlyn' : 'bg-crowlyn-button'} hover:bg-crowlyn hover:text-white text-white rounded-xl text-base sm:text-xl md:text-base px-3 py-2 my-2 mx-2 text-center`}>
                    {t(`consultation_project_content`)}
                </button>
                <button onClick={() => setActiveTab('marketing-content')}
                        className={`${activeTab === "marketing-content" ? 'bg-crowlyn' : 'bg-crowlyn-button'} hover:bg-crowlyn hover:text-white text-white rounded-xl text-base sm:text-xl md:text-base px-3 py-2 my-2 mx-2 text-center`}>
                    {t(`consultation_marketing_content`)}
                </button>
                <button onClick={() => setActiveTab('interview-content')}
                        className={`${activeTab === "interview-content" ? 'bg-crowlyn' : 'bg-crowlyn-button'} hover:bg-crowlyn hover:text-white text-white rounded-xl text-base sm:text-xl md:text-base px-3 py-2 my-2 mx-2 text-center`}>
                    {t(`consultation_interview_content`)}
                </button>
                <button onClick={() => setActiveTab('technical-interview-content')}
                        className={`${activeTab === "technical-interview-content" ? 'bg-crowlyn' : 'bg-crowlyn-button'} hover:bg-crowlyn hover:text-white text-white rounded-xl text-base sm:text-xl md:text-base px-3 py-2 my-2 mx-2 text-center`}>
                    {t(`consultation_technical_interview_content`)}
                </button>
            </div>
            <div className="w-full bg-white rounded-lg shadow-2xl">
                {activeTab === "technical-content" && <motion.div
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{
                        duration: 2, ease: "easeInOut", times: [0, 0.2, 0.5, 0.8, 1]
                    }}
                    id="technical-content" className="my-12 py-12">
                    <TitleGreenSpanSecond
                        id="section-why-us-custom-web-title"
                        namespace={namespace}
                        title="consultation.technical_title"
                        span="consultation.technical_span"
                        description="consultation.technical_text"
                    />
                    <div className="grid grid-cols-1 lg:grid-cols-2 px-5 mt-8 gap-12">
                        <div className="w-full text-justify">
                            <h3 className="text-2xl font-bold tracking-tight text-gray-900">{t('consultation.technical_highlights')}</h3>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_highlights_analysis')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_highlights_organization')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_highlights_stack')}</p>
                        </div>
                        <div className="w-full text-justify">
                            <h4 className="text-2xl font-bold tracking-tight text-gray-900">{t('consultation.technical_process')}</h4>
                            <p className="my-1 text-gray-500">{t('consultation.technical_process_consultation')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_process_depth_analysis')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_process_recommendation')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_process_implementation')}</p>
                        </div>
                        <div className="w-full text-justify col-span-2 justify-center">
                            <h5 className="text-xl font-bold tracking-tight text-gray-900">{t('consultation.technical_why')}</h5>
                            <p className="my-1 text-gray-500">{t('consultation.technical_why_experts')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_customized')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_support')}</p>
                        </div>
                    </div>
                </motion.div>}
                {activeTab === "project-content" && <motion.div
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{
                        duration: 2, ease: "easeInOut", times: [0, 0.2, 0.5, 0.8, 1]
                    }}
                    id="project-content" className="my-12 py-12">
                    <TitleGreenSpanSecond
                        id="section-why-us-custom-web-title"
                        namespace={namespace}
                        title="consultation.project_title"
                        span="consultation.project_span"
                        description="consultation.project_text"
                    />
                    <div className="grid grid-cols-1 lg:grid-cols-2 px-5 mt-8 gap-12">
                        <div className="w-full text-justify">
                            <h3 className="mt-6 mb-2 text-2xl font-bold tracking-tight text-gray-900">{t('consultation.project_highlights')}</h3>
                            <p className="mb-1 text-gray-500">{t('consultation.project_highlights_review')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.project_highlights_assurance')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.project_highlights_risk')}</p>
                        </div>
                        <div className="w-full text-justify">
                            <h4 className="mt-6 mb-2 text-2xl font-bold tracking-tight text-gray-900">{t('consultation.marketing_process')}</h4>
                            <p className="my-1 text-gray-500">{t('consultation.project_process_analysis')}</p>
                            <p className="my-1 text-gray-500">{t('consultation.project_process_assessment')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.project_process_recommendation')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.project_process_support')}</p>
                        </div>
                        <div className="w-full text-justify col-span-2 justify-center">
                            <h5 className="mt-6 mb-2 text-xl font-bold tracking-tight text-gray-900">{t('consultation.marketing_why')}</h5>
                            <p className="my-1 text-gray-500">{t('consultation.project_why_insights')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.project_why_data_evaluation')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.project_why_commitment')}</p>
                        </div>
                    </div>
                </motion.div>}
                {activeTab === "marketing-content" && <motion.div
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{
                        duration: 2, ease: "easeInOut", times: [0, 0.2, 0.5, 0.8, 1]
                    }}
                    id="marketing-content" className="my-12 py-12">
                    <TitleGreenSpanSecond
                        id="section-why-us-custom-web-title"
                        namespace={namespace}
                        title="consultation.marketing_title"
                        span="consultation.marketing_span"
                        description="consultation.marketing_text"
                    />
                    <div className="grid grid-cols-1 lg:grid-cols-2 px-5 mt-8 gap-12">
                        <div className="w-full text-justify">
                            <h3 className="mt-6 mb-2 text-2xl font-bold tracking-tight text-gray-900">{t('consultation.marketing_highlights')}</h3>
                            <p className="mb-1 text-gray-500">{t('consultation.marketing_highlights_plans')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.marketing_highlights_expertise')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.marketing_highlights_brand')}</p>
                        </div>
                        <div className="w-full text-justify">
                            <h4 className="mt-6 mb-2 text-2xl font-bold tracking-tight text-gray-900">{t('consultation.marketing_process')}</h4>
                            <p className="my-1 text-gray-500">{t('consultation.marketing_process_analysis')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.marketing_process_implementation')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.marketing_process_performance')}</p>
                        </div>
                        <div className="w-full text-justify col-span-2 justify-center">
                            <h5 className="mt-6 mb-2 text-xl font-bold tracking-tight text-gray-900">{t('consultation.marketing_why')}</h5>
                            <p className="my-1 text-gray-500">{t('consultation.marketing_why_holistic')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.marketing_why_data_driven')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.marketing_why_planning')}</p>
                        </div>
                    </div>
                    <div></div>
                </motion.div>}
                {activeTab === "interview-content" && <motion.div
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{
                        duration: 2, ease: "easeInOut", times: [0, 0.2, 0.5, 0.8, 1]
                    }}
                    id="interview-content" className="my-12 py-12">
                    <TitleGreenSpanSecond
                        id="section-why-us-custom-web-title"
                        namespace={namespace}
                        title="consultation.interview_title"
                        span="consultation.interview_span"
                        description="consultation.interview_text"
                    />
                    <div className="grid grid-cols-1 lg:grid-cols-2 px-5 mt-8 gap-12">
                        <div className="w-full text-justify">
                            <h3 className="mt-6 mb-2 text-2xl font-bold tracking-tight text-gray-900">{t('consultation.interview_highlights')}</h3>
                            <p className="mb-1 text-gray-500">{t('consultation.interview_workshops')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.interview_mock_interviews')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.interview_mock_coaching')}</p>
                        </div>
                        <div className="w-full text-justify">
                            <h4 className="mt-6 mb-2 text-2xl font-bold tracking-tight text-gray-900">{t('consultation.interview_process')}</h4>
                            <p className="my-1 text-gray-500">{t('consultation.interview_process_assessment')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.interview_process_preparation')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.interview_process_execution')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.interview_process_revision')}</p>
                        </div>
                        <div className="w-full text-justify col-span-2 justify-center">
                            <h5 className="mt-6 mb-2 text-xl font-bold tracking-tight text-gray-900">{t('consultation.interview_why')}</h5>
                            <p className="my-1 text-gray-500">{t('consultation.interview_why_crowlyn_guidance')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.interview_why_crowlyn_approach')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.interview_why_crowlyn_success')}</p>
                        </div>
                    </div>
                    <div></div>
                </motion.div>}
                {activeTab === "technical-interview-content" && <motion.div
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{
                        duration: 2, ease: "easeInOut", times: [0, 0.2, 0.5, 0.8, 1]
                    }}
                    id="technical-interview-content" className="my-12 py-12">
                    <TitleGreenSpanSecond
                        id="section-why-us-custom-web-title"
                        namespace={namespace}
                        title="consultation.technical_interview_title"
                        span="consultation.technical_interview_span"
                        description="consultation.technical_interview_text"
                    />
                    <div className="grid grid-cols-1 lg:grid-cols-2 px-5 mt-8 gap-12">
                        <div className="w-full text-justify">
                            <h3 className="mt-6 mb-2 text-2xl font-bold tracking-tight text-gray-900">{t('consultation.technical_interview_highlights')}</h3>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_interview_tech_assessment')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_interview_pers_assessment')}</p>
                        </div>
                        <div className="w-full text-justify">
                            <h4 className="mt-6 mb-2 text-2xl font-bold tracking-tight text-gray-900">{t('consultation.interview_process')}</h4>
                            <p className="my-1 text-gray-500">{t('consultation.technical_interview_process_interview')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_interview_process_interview')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_interview_process_feed_back')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_interview_process_guidance')}</p>
                        </div>
                        <div className="w-full text-justify col-span-2 justify-center">
                            <h5 className="mt-6 mb-2 text-xl font-bold tracking-tight text-gray-900">{t('consultation.interview_why')}</h5>
                            <p className="my-1 text-gray-500">{t('consultation.technical_interview_why_crowlyn_holistic')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_interview_why_crowlyn_transparency')}</p>
                            <p className="mb-1 text-gray-500">{t('consultation.technical_interview_why_crowlyn_experience')}</p>
                        </div>
                    </div>
                    <div></div>
                </motion.div>}
            </div>
        </div>)
}
export default ConsultationService;